/**
 * @gestionale/shared — Date utilities (Europe/Rome timezone)
 *
 * Single source of truth for all timezone-aware date operations.
 * All "today" / "date string" logic goes through here.
 */
/** Application timezone — Italian construction sites */
export const TIMEZONE = 'Europe/Rome';
/**
 * Today's date as YYYY-MM-DD in Europe/Rome timezone.
 */
export function oggiItalia() {
    return new Date().toLocaleDateString('sv-SE', { timeZone: TIMEZONE });
}
/**
 * Convert a Date object to YYYY-MM-DD in Europe/Rome timezone.
 */
export function toDateItalia(d) {
    return d.toLocaleDateString('sv-SE', { timeZone: TIMEZONE });
}
/**
 * Last day of a given month as YYYY-MM-DD string.
 * Pure arithmetic — no timezone conversion issues.
 */
export function ultimoGiornoMese(anno, mese) {
    const day = new Date(anno, mese, 0).getDate();
    return `${anno}-${String(mese).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
/**
 * First day of a given month as YYYY-MM-DD string.
 */
export function primoGiornoMese(anno, mese) {
    return `${anno}-${String(mese).padStart(2, '0')}-01`;
}
/**
 * Parse a YYYY-MM-DD string as local midnight (not UTC).
 * Avoids the off-by-one bug where `new Date('2025-01-31')` → Jan 30 23:00 in CET.
 */
export function parseDateLocal(dateStr) {
    return new Date(dateStr + 'T00:00:00');
}
//# sourceMappingURL=date.js.map